module.exports = __webpack_public_path__ + "static/media/cloud-island-bg-small.14cfa36a.svg";